
import DoctorsList from '@/components/Departments/common/DoctorsListTemplate2.vue';
import { DepartmentPropDataInterface } from '@/ts/interfaces';
import { defineComponent } from 'vue';

export default defineComponent({
  data(): DepartmentPropDataInterface {
    return {
      name: 'Neurosurgery Doctors',
      queryName: 'Neurosurgery',
      teamName: 'Neurosurgery team',
    };
  },
  components: { DoctorsList },
});
